// extracted by mini-css-extract-plugin
module.exports = {"pic_icon":"pic_icon___233pM"};